/* Name:Chaitali Khachane
   Description:This is the Configure screen, which will show the column level and Asset level rule
   in the form of tabular form which will show the column like column_name, dimension ,rule name, rule description etc
   we can edit the details of selected rule by clicking on edit icon
   In this screen we will also about to delete the rule by click on delete after it will get approved by delete pop up
   we can also able to active or detactivate the rule by toggle the toggle button available on each row action column.

*/

import { Button } from "primereact/button"
import { InputSwitch } from 'primereact/inputswitch'
import { Panel } from "primereact/panel"
import React, { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import DeletePopUp from "../../component/deletePopUp/deletePopUp"
import IconInputText from "../../component/iconInputText/iconInputText"
import { LabelHeading } from "../../component/LabelHeader/labelHeader.style"
import SelectButtonComp from "../../component/SelectButton/selectButtonComp"
import TableComponent from "../../component/Tables/tableComponent"
import { deleteConfigureDqAsset, deleteConfigureDqColumn, editAssetLevelRule, editColumnLevelRule, getConfigureDQAssetRule, getConfigureDQColumnRule, submitConfigureDQRule } from "../../redux/dataAsset/dataAsset.action"
import { SET_FORM_OPTION, SET_FORM_OPTION_OBJECT_VALUE, SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "../../redux/dataAsset/dataAsset.type"
import { Container, TableHeader } from "../global/global.style"
import AddNewRule from "./addNewRule"
import EditRule from "./editConfigureDQRule"
import { ProgressSpinner } from "primereact/progressspinner"
import DimensionWeightage from "./dimensionWeightage"
import { Dropdown } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"
import { rolePermissionMapping } from "../../data/userAccess/userRoleMapping"
import { checkButtonDisabledStatus } from "../../helpers/validation/userValidation"
import { useMemo } from "react"


function ConfigureDqRule({ changeDetail }) {
    const { apiData, formData } = useSelector((state) => state.dataAsset)
    const dispatch = useDispatch()
    const { dataAssetId } = useParams();
    const [ruleType, setRuleType] = useState("Column Level Rules")
    const [searchVal, setSearchVal] = useState("")
    const [enableRecommendation, setEnableRecommendation] = useState(false)
    const [checked, setChecked] = useState(true)
    const [showAddNewRulePopup, setShowAddNewRulePopup] = useState(false)
    const [DQRuleTableData, setDQRuleTableData] = useState({})
    const [enableEditColumnRule, setEnableEditColumnRule] = useState(false)
    const [editConfigureDQid, setEditConfigureDQid] = useState(false)
    const [enableDeletePopup, setEnableDeletePopup] = useState(false)
    const [pagination, setPagination] = useState({
        first: 0,   // index of the first record
        rows: 15,    // number of rows per page
    });
    const [selectedRuleFilter, setSelectedRuleFilter] = useState('all');
    const [addAccess, setAddAccess] = useState(false)
    const [editAccess, setEditAccess] = useState(false)
    const [deleteAccess, setDeleteAccess] = useState(false)


    // Handle page change
    const handlePageChange = (e) => {
        setPagination({
            first: e.first,   // new first record index
            rows: e.rows,     // new number of rows per page
        });
    };

    //this method will set the selected row id and enable delete pop up button
    const handleRowDeleteClick = (rowData) => {
        setEditConfigureDQid(rowData.id)
        setEnableDeletePopup(true)
    };

    //in this we will return the table date according to selected switch button either we have to show colmn level
    //data or Asset level data and also filter the search value 
    const getTotalTableData = () => {
        let tempValue = []
        if (ruleType === "Column Level Rules") {

            if (searchVal === "") {
                tempValue = JSON.parse(JSON.stringify(formData.configureColumnDQRuleform.options))
            } else {
                tempValue = formData.configureColumnDQRuleform.options.filter((val) => val.column_name.toLowerCase().includes(searchVal.toLowerCase()))

            }
        } else if (ruleType === "Asset Level Rules") {
            if (searchVal === "") {
                tempValue = JSON.parse(JSON.stringify(formData.configureAssetDQRuleform.options))
            } else {
                tempValue = formData.configureAssetDQRuleform.options.filter((val) => val.dimension.toLowerCase().includes(searchVal.toLowerCase()))

            }

        }
        return selectedRuleFilter === "all" ? tempValue : selectedRuleFilter === 'inactive' ? tempValue.filter((val) => val.is_active === false) : tempValue.filter((val) => val.is_active === true)

    }

    const getTableData = () => {
        let tempValue = []
        if (ruleType === "Column Level Rules") {

            if (searchVal === "") {
                tempValue = formData.configureColumnDQRuleform.options.slice(pagination.first, pagination.first + pagination.rows)
            } else {
                tempValue = formData.configureColumnDQRuleform.options.filter((val) => val.column_name.toLowerCase().includes(searchVal.toLowerCase())).slice(pagination.first, pagination.first + pagination.rows)

            }
        } else if (ruleType === "Asset Level Rules") {
            if (searchVal === "") {
                tempValue = formData.configureAssetDQRuleform.options.slice(pagination.first, pagination.first + pagination.rows)
            } else {
                tempValue = formData.configureAssetDQRuleform.options.filter((val) => val.dimension.toLowerCase().includes(searchVal.toLowerCase())).slice(pagination.first, pagination.first + pagination.rows)
            }

        }
        return selectedRuleFilter === "all" ? tempValue.slice(pagination.first, pagination.first + pagination.rows) : selectedRuleFilter === 'inactive' ? tempValue.filter((val) => val.is_active === false).slice(pagination.first, pagination.first + pagination.rows) : tempValue.filter((val) => val.is_active === true).slice(pagination.first, pagination.first + pagination.rows)

    }
    //in this method we will handle the toogle button to activate or deactivate the rule 
    const onRowSwitchChange = (e, rowData, type) => {
        // Find the row for which the toggle is clicked and update the value for that row
        if (ruleType === "Column Level Rules") {
            dispatch({
                type: SET_FORM_OPTION_OBJECT_VALUE,
                payload: {
                    formField: "configureColumnDQRuleform",
                    id: rowData.id,
                    idField: "id",
                    optionField: type,
                    value: e.value
                }
            })
        } else if (ruleType === "Asset Level Rules") {
            dispatch({
                type: SET_FORM_OPTION_OBJECT_VALUE,
                payload: {
                    formField: "configureAssetDQRuleform",
                    id: rowData.id,
                    idField: "id",
                    optionField: type,
                    value: e.value
                }
            })
        }
    };
    //this the action column template, in which we have to render the toggle button, edit and delete icon in each 
    //row of table
    const actionTemplete = (rowData) => {
        return <div style={{ display: "flex" }}>
            {/* <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)}  style={{width:"40px",height:"16px",verticalAlign:"super"}}/> */}
            <div style={{ alignSelf: "end" }}>
                <InputSwitch
                    disabled={isDisabledAction} 
                    checked={rowData.is_active} onChange={(e) => {
                        if (ruleType === "Asset Level Rules") {
                            dispatch(editAssetLevelRule(rowData.id, dataAssetId, rowData.rule_description, rowData.threshold_value, rowData.threshold_type, e.value, rowData.driftValue, rowData.driftWindow))
                        } else {
                            // onRowSwitchChange(e, rowData, "is_active")
                            dispatch(editColumnLevelRule(rowData.id, dataAssetId, rowData.rule_description, rowData.threshold_value, rowData.threshold_type, e.value, (rowData.drift_value), rowData.drift_type,rowData.expression,rowData.check_expression))
                        }
                    }

                    }
                    style={{ width: "40px", height: "16px", verticalAlign: "super" }} />

            </div>
            <Button
                disabled={isDisabledAction}
                onClick={(e) => {
                    setEditConfigureDQid(rowData.id)
                    setEnableEditColumnRule(true)
                }
                } style={{ paddingTop: "17px", color: "#000000B2", backgroundColor: "transparent", border: "none" }} icon="pi pi-pencil" />
            <Button
                disabled={isDisabledAction}
                style={{ paddingTop: "17px", color: "#000000B2", backgroundColor: "transparent", border: "none" }} onClick={() => handleRowDeleteClick(rowData)} icon="pi pi-trash" />
        </div>
    }
    const ruleOptions = [
        { label: 'All Rules', value: 'all' },
        { label: 'Active Rules', value: 'active' },
        { label: 'Inactive Rules', value: 'inactive' },
    ];
    const handleChange = (e) => {
        setSelectedRuleFilter(e.value);
    };
    //In this method we will return the columns for selected rule type as both the rule have different column
    const getTableColumns = () => {
        if (ruleType === "Column Level Rules") {
            return [
                { field: "column_name", header: <TableHeader style={{ fontSize: "12px", width: "200px" }}>Column Name</TableHeader>, style: { width: "100px", overflowWrap: "anywhere" } },
                { field: "dimension", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>Dimension</TableHeader>, style: { width: "100px", overflowWrap: "anywhere" } },
                { field: "rules_name", header: <TableHeader style={{ fontSize: "12px", width: "200px" }}>Rule Name</TableHeader>, style: { width: "200px", overflowWrap: "anywhere" } },
                { field: "rule_description", header: <TableHeader style={{ fontSize: "12px", width: "200px" }}>Rule Description</TableHeader>, style: { width: "200px", overflowWrap: "anywhere" } },
                { field: "dq_rule_check", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>DQ Rule Check</TableHeader>, style: { width: "100px", overflowWrap: "anywhere" } },
                // { field: "threshold_type", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>Threshold Type</TableHeader>, body: (rowData) => templateType(rowData, "threshold_type"), style: { width: "100px" } },
                // { field: "threshold_value", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>Threshold Value</TableHeader>, body: (rowData) => templateType(rowData, "threshold_value"), style: { width: "100px" } },
                { field: "action", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>Action</TableHeader>, body: actionTemplete, style: { width: "150px" } }
            ]
        }
        else if (ruleType === "Asset Level Rules") {
            return [
                // { field: "srNo", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>S.No</TableHeader>, style: { width: "30px", overflowWrap: "anywhere" } },
                { field: "dimension", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>Dimension</TableHeader>, style: { width: "100px", overflowWrap: "anywhere" } },
                { field: "rules_name", header: <TableHeader style={{ fontSize: "12px", width: "200px" }}>Rule Name</TableHeader>, style: { width: "200px", overflowWrap: "anywhere" } },
                { field: "rule_description", header: <TableHeader style={{ fontSize: "12px", width: "200px" }}>Description</TableHeader>, style: { width: "100px", overflowWrap: "anywhere" } },
                { field: "check_name", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>DQ Rule Check</TableHeader>, style: { width: "100px", overflowWrap: "anywhere" } },
                // { field: "threshold_type", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>Threshold Type</TableHeader>, style: { width: "100px", overflowWrap: "anywhere" } },
                // { field: "threshold_value", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>Threshold Value</TableHeader>, style: { width: "100px", overflowWrap: "anywhere" } },
                {
                    field: "action", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>Action</TableHeader>,
                    body: actionTemplete,
                    style: { width: "100px" }
                }
            ]
        }
    }

    //this method will get called after we approved delete button pop up
    //in this mehod we will call delete API and close the delete pop up

    const deleteApproved = () => {
        if (ruleType === "Column Level Rules") {
            dispatch(deleteConfigureDqColumn(editConfigureDQid, dataAssetId))
            setEnableDeletePopup(false)
        } else if (ruleType === "Asset Level Rules") {
            dispatch(deleteConfigureDqAsset(editConfigureDQid, dataAssetId))
            setEnableDeletePopup(false)
        }
    }

    //this method will enable the add new rule screen 
    //this method will get called once we click on "Add New Rule" button
    const addNewRules = () => {
        setShowAddNewRulePopup(true)
    }
    const getConfigureDqRuleTableData = () => {
        if (searchVal === "") {
            return DQRuleTableData
        } else {
            return DQRuleTableData.filter((val) => val.column_name.toLowerCase().includes(searchVal.toLowerCase()))

        }
    }

    const templateType = (rowData, type) => {
        console.log(rowData)
        switch (type) {
            case "threshold_type":
                console.log("rowData")
                console.log(rowData)
                return <Fragment>
                    <Dropdown
                        style={{ width: "100px" }}
                        value={{ name: rowData[type] }} onChange={(e) => {
                            console.log("event ", e)
                            dispatch({
                                type: SET_FORM_OPTION_OBJECT_VALUE,
                                payload: {
                                    formField: "configureColumnDQRuleform",
                                    id: rowData.id,
                                    idField: "id",
                                    optionField: type,
                                    value: e.value.name
                                }
                            })
                        }} options={formData.threshold_type.options} optionLabel="name"
                        placeholder="Select Type" className="w-full" />
                </Fragment>
            case "threshold_value":
                return <Fragment>

                    <InputNumber
                        disabled={rowData.threshold_type !== "" && rowData.threshold_type !== null ? false : true}
                        className="custom-input"
                        style={{ width: "100px" }}
                        inputId="integeronly"
                        value={rowData[type]}
                        onValueChange={(e) => {
                            console.log("event ", e)
                            dispatch({
                                type: SET_FORM_OPTION_OBJECT_VALUE,
                                payload: {
                                    formField: "configureColumnDQRuleform",
                                    id: rowData.id,
                                    idField: "id",
                                    optionField: type,
                                    value: e.value
                                }
                            })
                        }} />
                </Fragment>

            default:
                return <span style={{ display: "block", overflowWrap: "anywhere", width: "100px" }}>{rowData[type]}</span>

        }

    }
        
         const access = apiData?.assetSummary?.data?.access || [];  
         const role = access?.[0]?.role_permission_id;
            const isDisabledAction = useMemo(() => {
                return role
                  ? checkButtonDisabledStatus(
                      access,
                      role,
                      "Configure Rules [Add, Edit, Delete]",
                      rolePermissionMapping?.[role]?.buttons || {}
                    )
                  : true;
              }, [role, access, rolePermissionMapping]);

    useEffect(() => {
        if (apiData.assetSummary.data.access.length === 0 && (apiData.assetSummary.data.created_by !== localStorage.getItem("userName") && !apiData.assetSummary.data.access[0]?.permission_description.includes("Configure Rules"))) {

        } else {
            const indexOfString = apiData.assetSummary.data.access[0].permission_description.indexOf("Configure Rules")
            const nextCommaIndex = apiData.assetSummary.data.access[0].permission_description.indexOf(",", indexOfString);
            let result;

            if (nextCommaIndex !== -1) {
                result = apiData.assetSummary.data.access[0].permission_description.slice(indexOfString, nextCommaIndex);
            } else {
                // If no comma is found, take the rest of the string
                result = apiData.assetSummary.data.access[0].permission_description.slice(indexOfString);
            }
            if (result.includes("Add")) {
                setAddAccess(true)
            }
            if (result.includes("Edit")) {
                setEditAccess(true)
            }
            if (result.includes("Delete")) {
                setDeleteAccess(true)
            }
        }
    }, [])
    return <Fragment>
        {apiData.configureAssetDQRule.loading || apiData.configureColumnDQRule.loading ? <div style={{ width: "100%", textAlign: "center", lineHeight: window.innerHeight + "px", verticalAlign: "middle" }}><ProgressSpinner /></div>
            :
            <Container style={{ height: "90%" }}>
                <div className="grid">
                    <div className="col-12">
                        <LabelHeading style={{
                        }}>Configure DQ Rules</LabelHeading>
                    </div>
                </div>
                <div className="grid" style={{ marginTop: "5px", width: "100%" }}>
                    <div className="col-5" style={{ paddingBottom: "10px" }}>
                        <SelectButtonComp style={{ height: "20px" }} value={{ name: ruleType }} onChange={(e) => setRuleType(e.value.name)} optionLabel="name" options={[
                            { name: "Asset Level Rules" },
                            { name: "Column Level Rules" },
                            { name: "Dimension Weightage" }
                        ]} />
                    </div>
                </div>
                {ruleType === "Asset Level Rules" || ruleType === "Column Level Rules" ? <Panel>
                    <div className="grid" >
                        <div className="col-4" style={{}}>
                            <IconInputText iconPosition="left" style={{ width: "85%", height: "40px" }} value={searchVal} onChange={(e) => { setSearchVal(e.target.value) }} iconName="pi-search" placeholderName="Search Columns" />
                        </div>
                        {/* <div className="col-1">
                        </div> */}
                        <div className="col-2" style={{ textAlign: "right" }}>
                        </div>
                        <div className="col-6" style={{ textAlign: "right" }}>
                            <Button 
                             disabled={isDisabledAction}
                             type="button" label="New Rule" icon="pi pi-plus" iconPos="left" style={{ marginRight: "5px", height: "40px" }} onClick={() => { addNewRules() }} />
                            <Dropdown
                                defaultValue={'all'}
                                value={selectedRuleFilter}
                                options={ruleOptions}
                                onChange={handleChange}
                                placeholder="Filter Rule"
                                style={{ marginRight: "5px" }}
                            />
                            {/* <Button style={{ marginRight: "5px", width: "43px", height: "40px" }} icon="pi pi-filter" outlined /> */}
                            <Button style={{ width: "43px", height: "40px" }} icon="pi pi-refresh" outlined onClick={() => {
                                if (ruleType === "Column Level Rules") {
                                    dispatch(getConfigureDQColumnRule(dataAssetId))
                                } else if (ruleType === "Asset Level Rules") {
                                    dispatch(getConfigureDQAssetRule(dataAssetId))
                                }
                            }} />

                        </div>


                    </div>
                    <hr style={{
                        margin: "0px",
                        border: "0", /* Remove default border */
                        height: "1px", /* Set the height of the line */
                        backgroundColor: "#e3d8d8" /* Change the color */
                    }} />
                    <TableComponent checked={false}
                        paginator
                        rows={pagination.rows}
                        first={pagination.first}
                        totalRecords={getTotalTableData().length}
                        onPage={handlePageChange}  // Handle page change
                        rowsPerPageOptions={[15, 30, 45]}  // Options to change rows per page
                        virtualScroll  // Use virtual scrolling
                        lazy           // Enable lazy loading
                        className="p-datatable-sm"
                        size="small"
                        selection={formData.selectedProfile.options}
                        onSelectionChange={(e) => {
                            dispatch({
                                type: SET_FORM_OPTION,
                                payload: {
                                    // TO DO: not sure about this
                                    formField: "selectedProfile",
                                    data: e.value
                                }
                            })
                        }
                        } columns={getTableColumns()}
                        tableData={getTableData()} />
                </Panel> : <DimensionWeightage />}
                {/* {ruleType === "Column Level Rules" ?
                    <div className="grid" style={{ marginTop: "20px", textAlign: "right" }}>
                        <div className="col-12">
                            <Button onClick={() => { dispatch(submitConfigureDQRule(dataAssetId)) }} label="Next" icon="pi pi-arrow-right" iconPos="right" />
                        </div>
                    </div> : null} */}
                {showAddNewRulePopup && <AddNewRule dataAssetId={dataAssetId} changeDetail={changeDetail} ruleType={ruleType} onHide={() => { setShowAddNewRulePopup(false) }} />}
                {enableEditColumnRule && <EditRule dataAssetId={dataAssetId} editObjectId={editConfigureDQid} changeDetail={changeDetail} ruleType={ruleType} onHide={() => { setEnableEditColumnRule(false) }} />}
                {enableDeletePopup && <DeletePopUp onHide={() => setEnableDeletePopup(false)} deleteApproved={deleteApproved} header="Delete Column" message="Are you sure, you want to delete this column? This action cannot be undone" />}

            </Container>
        }
    </Fragment>
}

export default ConfigureDqRule